import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppActions } from "../app.actions";
import { AppState } from "../app.state";

export const coverageGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);

  return store.select(AppState.getCoverages).pipe(
    mergeMap((coverages) => {
      if (!coverages) {
        return store.dispatch(new AppActions.Coverage.Get()).pipe(
          map(() => true),
          catchError(() => of(false))
        );
      }
      return of(true);
    }),
    catchError(() => of(false))
  );
};
